<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs11 md5 lg3>
        <v-card class="pa-4 elevation-5">
          <v-card-title class="display-font display-1">Sign Up</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="signUp">
              <v-layout column>
                <v-flex>
                  <v-text-field
                    v-model="email"
                    label="Email"
                    placeholder=" "
                    :error-messages="emailError"
                    @input="clearError"
                  />
                </v-flex>

                <v-text-field
                  v-model="password"
                  type="password"
                  label="Password"
                  placeholder=" "
                  :error-messages="passwordError"
                  @input="clearError"
                />
                <v-text-field
                  v-model="confirmation"
                  type="password"
                  label="Confirm Password"
                  placeholder=" "
                  :error-messages="confirmationError"
                />
              </v-layout>

              <v-layout>
                <v-btn type="submit" color="primary">Sign Up</v-btn>
                <router-link :to="{ name: 'signIn' }">
                  <v-btn flat>Sign In</v-btn>
                </router-link>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Auth from "@/classes/Auth";
export default {
  data() {
    return {
      email: "",
      password: "",
      confirmation: "",
      auth: new Auth(),
      error: undefined
    };
  },
  computed: {
    ...mapState(["user"]),
    isAnonymous() {
      return this.user != undefined && this.user.isAnonymous;
    },
    emailError: function() {
      if (this.error != undefined) {
        if (this.error.target == "email") {
          return this.error.msg;
        } else if (this.error.target == "all") {
          return " ";
        }
      }
      return undefined;
    },
    passwordError: function() {
      if (this.error != undefined) {
        if (this.error.target == "password" || this.error.target == "all") {
          return this.error.msg;
        }
      }
      return undefined;
    },
    confirmationError: function() {
      if (this.confirmation == undefined) {
        return "Password must be confirmed";
      }
      if (this.confirmation !== this.password) {
        return "Your password and confirmation password do not match";
      }
      return undefined;
    }
  },
  methods: {
    async signUp() {
      this.error = undefined;
      if (this.confirmation === this.password) {
        try {
          if (this.isAnonymous) {
            await this.auth.signUpAnonymousUser(
              this.user,
              this.email,
              this.password
            );
          } else {
            await this.auth.signUp({
              email: this.email,
              password: this.password,
              confirmation: this.confirmation
            });
          }

          this.$router.push({ name: "home" });
        } catch (e) {
          console.log(e);
          this.error = e;
        }
      }
    },
    clearError() {
      this.error = undefined;
    }
  }
};
</script>
